import React, { Component } from 'react'
import { ActionArrow, QuoteMark, Close } from './icons'
import TestimonialCard from './cards/testimonial'

class Testimonials extends Component {

  state = {
    lightbox: false,
    testimonial: 0,
  }

  constructor(props) {
    super(props)
    this.slider = React.createRef()
  }

  componentDidMount() {
    let isDown = false;
    let startX;
    let scrollLeft;
    this.initial = 0;

    this.slider.current.addEventListener('mousedown', (event) => {
      isDown = true;
      startX = event.pageX - this.slider.current.offsetLeft;
      scrollLeft = this.slider.current.scrollLeft;
      this.initial = 0;
    });
    this.slider.current.addEventListener('mouseleave', (event) => {
      isDown = false;
    });
    this.slider.current.addEventListener('mouseup', (event) => {
      isDown = false;
    });
    this.slider.current.addEventListener('mousemove', (event) => {
      if(!isDown) return;
      event.preventDefault();
      const x = event.pageX - this.slider.current.offsetLeft;
      const walk = (x - startX) * 2; //scroll-fast
      this.initial += Math.abs(walk);
      this.slider.current.scrollLeft = scrollLeft - walk;
    });
  }

  showLightbox = (id) => {
    this.setState({ 
      testimonial: id,
      lightbox: true,
    })
  }

  sliderLink = (event) => {
    if (this.initial > 10) event.preventDefault();
  }

  render() {

    let { testimonials } = this.props
    let { lightbox, testimonial } = this.state

    return (
      <section className='testimonials'>

        <div className='testimonials__content'>

          { testimonials?.length > 0 &&

            <div className='testimonials__slides'>

              <div className='testimonials__slider' ref={this.slider}>
                  
                {testimonials.map((el, i) => (
                  <div className='testimonials__slide' key={i}>
                    <TestimonialCard {...el} index={i} showLightbox={this.showLightbox} />
                  </div>
                ))}

              </div>
               
             </div>
          }
        </div>

        { lightbox && testimonials?.length > 0 &&
          <>
            <div className='testimonial-popup__overlay' />
            <div className='testimonial-popup'>
              <button 
                className=''
                onClick={() => this.setState({ lightbox: false })}
              >
                <Close color='#FFFFFF' />
              </button>
              <div className='testimonial-popup__details'>
                <QuoteMark color='#91A0C1' />
                <div className='copy' dangerouslySetInnerHTML={{ __html: testimonials[testimonial].quote }} />
                <p className='name'>{ testimonials[testimonial].name }</p>
                <p className='location'>{ testimonials[testimonial].location }</p>
              </div>
            </div>
          </>
        }

      </section>
    )
  }
}

export default Testimonials
